import styled from '@emotion/styled/macro'
import { Tabs as BootTabs } from 'react-bootstrap'

import { flexCenter } from 'style/emotion'
import mediaQuery from 'share/utils/mediaQuery'

const Tabs = styled(BootTabs)`
  &.nav {
    ${flexCenter}

    align-items: stretch;
    border-bottom: 1px solid var(--primary);
    flex-wrap: nowrap;
    height: auto;
    justify-content: flex-start;
    margin-bottom: 24px;
    width: auto;

    ${mediaQuery('mobile')} {
      justify-content: center;
    }

    & .nav-item.nav-link {
      background-color: var(--london-fog);
      border-bottom: 1px solid var(--primary);
      border-radius: 0px;
      color: inherit;
      min-width: 150px;
      text-align: center;

      ${mediaQuery('mobile')} {
        flex: 1;
        min-width: 50%;
      }

      &.active {
        background-color: white;
        border-radius: 0px;
        border: 1px solid var(--primary);
        border-bottom: none;
        color: var(--primary);
        font-weight: 500;
      }
    }
  }
`

export { Tabs }
